import React from "react";
import { Tooltip } from "antd";

/**
 * A reusable component that truncates long text and shows the full value in a Tooltip.
 *
 * @param {string} text - The full text to display.
 * @param {number} maxLength - Max characters to show before truncating (default: 20).
 * @param {React.CSSProperties} style - Optional inline styles.
 * @param {string} className - Optional className for styling.
 */
const TooltipWrapper = ({ text, maxLength = 20, style, className }) => {
  if (!text) return null;

  const shouldTruncate = text.length > maxLength;
  const displayText = shouldTruncate ? text.slice(0, maxLength - 3) + "..." : text;

  return shouldTruncate ? (
    <Tooltip title={text} color="white">
      <span className={className} style={style}>
        {displayText}
      </span>
    </Tooltip>
  ) : (
    <span className={className} style={style}>
      {text}
    </span>
  );
};

export default TooltipWrapper;
